import React from "react";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";

const MapWithAMarker = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap defaultZoom={15} defaultCenter={props.center}>
      <Marker position={props.marker} />
    </GoogleMap>
  ))
);

export default MapWithAMarker;



// WEBPACK FOOTER //
// ./src/components/Maps.js